export const user = `
  {
    name
    last_name
    full_name
    username
    email
    email_verifiedAt
    mobile
    mobile_verifiedAt
    gender
    birthday
    nickname
    access_id
    media {
      url
    }
  }
`;

export const user_summery = `
  {
    name
    last_name
    full_name
    username
    nickname
    email
    gender
    mobile
    mobile_verifiedAt
    access_id
    birthday
    has_password
    is_partner
    user_information 
    price_group {
      title
      user_group_acls
    }
    referrer {
      full_name
      nickname
      email
      mobile
    }
    companies {
      id
      is_verified
      title
      address
      city {
            id
            name
            native
        }
        state {
            id
            name
            native
        }
    }
    media {
      url
    }
  }
`;
export const user_profile = `
  {
    name
    last_name
    full_name
    username
    nickname
    email
    gender
    mobile
    access_id
    birthday
    has_password
    is_partner
    price_group {
      title
      user_group_acls
    }
    referrer {
      full_name
      nickname
      email
      mobile
    }
    companies {
      id
      title
      address
      city {
            id
            name
            native
        }
        state {
            id
            name
            native
        }
      state_id
      city_id
      postal_code
      address
      registration_id
      national_id
      phone
      is_verified
    }
    media {
      url
    }
  }
`;
// Public author page fields only. `email`, `gender` and `access_name` (the panel role, e.g. "admin") were selected
// too, so every site reading an author without its own `author_mockup` carried the author's email into the page
// (chawk-bazar). `custom_fields` holds the author's bio (`description`).
export const author = `
  {
    id
    name
    last_name
    full_name
    custom_fields
    media {
      url
      alt
    }
    seo {
      full_url
    }
  }
`;
